import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";

export const DiceTestSuccessDialog = ({
  diceTestSuccessDialogOpen,
  setDiceTestSuccessDialogOpen,
}: {
  diceTestSuccessDialogOpen: boolean;
  setDiceTestSuccessDialogOpen: Dispatcher<boolean>;
}) => {
  return (
    <Dialog open={diceTestSuccessDialogOpen}>
      <DialogContent>
        <p className="font-mulish text-[20px]">Dice test succeeded!</p>
        <br></br>
        <p>
          The test alert successfully reached your Dice server. If you are
          still experiencing issues viewing alerts in Dice, please contact
          support@actuate.ai.{" "}
        </p>
      </DialogContent>
      <DialogActions>
        <OrangeTextButton
          onClick={() => {
            setDiceTestSuccessDialogOpen(false);
          }}
          text="Ok"
          disabled={false}
        />
      </DialogActions>
    </Dialog>
  );
};
